// extracted by mini-css-extract-plugin
export default {"p_content":"_45ead9304d"};